import React, { useState, createElement, useEffect } from "react";
import {
  Divider,
  Grid,
  makeStyles,
  Box,
  Typography,
  IconButton,
  useTheme,
  Container,
  MenuItem,
  useMediaQuery,
  Modal,
  Backdrop,
  Fade,
  Checkbox,
  FormControlLabel,
  Select,
  Button,
  TextareaAutosize,
  FormControl,
  FormHelperText,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useForm, Controller, useWatch } from "react-hook-form";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as FbIcon } from "../../images/socialIcons/FbIcon.svg";
import { ReactComponent as WhatsApp } from "../../images/socialIcons/WhatsApp.svg";
import { ReactComponent as WeChatIcon } from "../../images/socialIcons/WeChatIcon.svg";
import { ReactComponent as LineIcon } from "../../images/socialIcons/LineIcon.svg";

import { Card, CardContent } from "../../components/Card";
import divisions from "../../divisions.json";
import TabView from "../../components/TabView";
import VerificationCode from "../../pages/VerificationCode";
import "../../responsiveImage.css";
import { useAlert } from "../../components/Alert";
import ChoiceProperty from "../../pages/ChoiceProperty";
import SearchPropertyResult from "../../pages/SearchPropertyResult";

const GET_EXCLUSIVEWEB = gql`
  query exclusiveWeb($id: Int!) {
    exclusiveWeb(id: $id) {
      id
      siteTitle
      homePageTitle
      companyName
      mobile
      phone
      fax
      email
      address
      imageUrl
      url
      aboutUs {
        id
        content
      }
    }
  }
`;

export default function PreviewScreen({ id }) {
  const isDownSm = useMediaQuery("(max-width:600px)");
  const isPhone = useMediaQuery("(max-width:460px)");
  const useStyles = makeStyles((theme) => ({
    footerLinksList: {
      borderBottom: isDownSm
        ? `1px dotted ${theme.palette.secondary.light}`
        : "",
    },
    footerLinks: {
      color: theme.palette.secondary.light,
      marginTop: isDownSm ? "10px" : "",
      cursor: "pointer",
      lineHeight: "2",
    },
    footerInfoText: {
      letterSpacing: "1.2px",
      lineHeight: 1.6,
    },
    iconBox: {},
    iconButton: {
      transition: "all 0.3s",
      "&+&": {
        marginLeft: "10px",
      },
      "&:hover": {
        transform: "translateY(-10px)",
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));
  const classes = useStyles();
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      select: 0,
      propertyData: "",
    },
  });

  const footerList = [
    {
      list: [
        {
          label1: "富屋實業有限公司",
          label2: "總部地址：台中市南屯區大英西一街61號",
        },
      ],
    },
    {
      list: [
        {
          label1: "傳真：(04)2473-3106",
          label2: "電話：(04)2471-7673",
          label3: "加盟專線：0800-800-680",
        },
      ],
    },
  ];
  const tabArray = ["熱門物件", "關於我們", "Q & A", "聯絡我們"];
  const { data, loading } = useQuery(GET_EXCLUSIVEWEB, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id,
    },
  });
  if (data) {
    return (
      <Card>
        <div class="container">
          <ResponsiveImage
            src={require("../../images/bulelogo.jpg").default}
            width={2117}
            height={350}
          />
          <div class={"top-left"}>{data.exclusiveWeb?.homePageTitle ?? ""}</div>
          <div class="bottom-right">
            {`https://new.5137.com.tw/${data.exclusiveWeb?.url ?? ""}`}
          </div>
        </div>
        <Grid
          container
          justifyContent="center"
          style={{ paddingBottom: "20px" }}
        >
          <Grid item>
            <Controller
              name="select"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TabView
                  centered
                  tabs={tabArray}
                  index={field.value}
                  onChange={field.onChange}
                >
                  <EasySearch
                    onChangeTab={(v) => {
                      setValue("propertyData", v);
                      setValue("select", 3);
                    }}
                  />
                  <AboutUs data={data.exclusiveWeb?.aboutUs?.content} />
                  <QA />
                  <ConnectUS
                    data={data}
                    propertyData={getValues("propertyData")}
                  />
                </TabView>
              )}
            />
          </Grid>
        </Grid>
        <Divider />
        <Grid container xs={12} style={{ margin: "2em 0" }}>
          {footerList.map((item, index) => {
            return (
              <Grid item container xs={index == 2 ? 12 : 12} md={6}>
                {item.list.map((item) => {
                  return (
                    // 這邊
                    <Box pl={isPhone ? "" : 4} mt={2}>
                      <Typography
                        variant="body2"
                        component={index == 2 ? "span" : ""}
                        className={classes.footerInfoText}
                        style={{ color: "#103775" }}
                      >
                        {item.label1}
                      </Typography>
                      <Typography
                        variant="body2"
                        component={index == 2 ? "span" : ""}
                        className={classes.footerInfoText}
                        style={{ color: "#103775" }}
                      >
                        {item.label2}
                      </Typography>
                      <Typography
                        variant="body2"
                        component={index == 2 ? "span" : ""}
                        className={classes.footerInfoText}
                        style={{ color: "#103775" }}
                      >
                        {item.label3}
                      </Typography>
                    </Box>
                  );
                })}
              </Grid>
            );
          })}
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <FooterIconsModal />
          </Grid>
          <Grid item xs={12}>
            <Box py={2}>
              <Typography
                variant={isPhone ? "caption" : "body2"}
                align="center"
                style={{ color: "#103775" }}
              >
                Copyright &copy; 2021 富屋實業有限公司 版權所有
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Card>
    );
  } else {
    return null;
  }
}

function EasySearch({ onChangeTab = () => {} }) {
  let city = Object.keys(divisions);
  const history = useHistory();
  const isPhone5 = useMediaQuery("(max-width:320px)");
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");

  const [selectDistrict, setSelectDistrict] = useState();
  const [searchData, setSearchData] = useState();
  const [search, setSearch] = useState(false);
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
      minHeight: "400px",
    },
    backImg: {
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: 0,
    },
    contentBox: {
      justifyContent: "center",
    },
    selectBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      backgroundColor: "white",
      height: isPhone ? "45px" : isPad ? "55px" : "65px",
      borderRadius: isPhone ? "22px" : isPad ? "30px" : "35px",
      marginBottom: "10px",
      zIndex: 0,
    },
    selectGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRight: "1px solid black",
    },
    select: {
      lineHeight: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      backgroundColor: "transparent",
      padding: isPhone ? "0px 10px" : "0px 20px",
      fontSize: isPhone ? "0.75rem" : "1rem",
      width: isPhone5
        ? "35px"
        : isPhone
        ? "35px"
        : isPad
        ? "50px"
        : isTable
        ? "75px"
        : "100px",
      height: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      textOverflow: "ellipsis",
      "&.MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
    },
    buttonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px",
    },
    button: {
      backgroundColor: "#E1B663",
      color: "white",
      width: isPhone ? "170px" : isPad ? "200px" : isTable ? "250px" : "270px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: "#E1B663",
      },
    },

    checkBox: {
      color: "lightgrayblue",
      marginLeft: "15px",
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
      },
      "&:not($checked) .MuiIconButton-label:after": {
        content: '""',
        left: 5,
        top: 5,
        height: "20px",
        width: "20px",
        position: "absolute",
        backgroundColor: "white",
        zIndex: -1,
      },
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "#103775",
      },
      "& .MuiSvgIcon-root": {
        height: "30px",
        width: "30px",
      },
    },
  }));
  const classes = useStyles();

  const typeArray = ["土地", "建物"];

  const [type, setType] = useState(["土地", "建物"]);

  const typeChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setType(type.length === typeArray.length ? [] : typeArray);
      return;
    }
    setType(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // 簡易查詢按鈕 submit
  function _submit(data) {
    setSearchData(data);
    setSearch(true);
  }

  return (
    <Box>
      <Box className={classes.backBox}>
        <img
          src="/assets/images/Home/findBestPlace.png"
          className={classes.backImg}
        />
        <Grid
          container
          style={{
            justifyContent: "center",
            alignItems: "center",
            height: isPhone ? "500px" : isPad ? "600px" : "700px",
          }}
        >
          <Grid container item xs={12} lg={10} className={classes.contentBox}>
            <Grid
              container
              item
              xs={11}
              sm={9}
              md={7}
              lg={7}
              className={classes.selectBox}
            >
              <Grid item xs={3} lg={3} className={classes.selectGrid}>
                <Select
                  native
                  {...register("district")}
                  classes={{ root: classes.select }}
                  disableUnderline
                  onChange={(e) => {
                    setSelectDistrict(
                      divisions[city[e.target.selectedIndex - 1]].subdivisions
                    );
                  }}
                >
                  <option disabled selected value="">
                    縣市
                  </option>
                  {Object.keys(divisions).map((item, index) => (
                    <option key={item}>{divisions[city[index]].zhTW}</option>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={3} lg={3} className={classes.selectGrid}>
                <Select
                  native
                  {...register("subdistrict")}
                  classes={{ root: classes.select }}
                  disableUnderline
                >
                  <option disabled selected value="">
                    鄉鎮/區域
                  </option>
                  {selectDistrict !== undefined
                    ? Object.keys(selectDistrict)
                        .map((item) => selectDistrict[item].zhTW)
                        .map((item, index) => (
                          <option key={item}>{item}</option>
                        ))
                    : null}
                </Select>
              </Grid>
              <Grid item xs={3} lg={3} className={classes.selectGrid}>
                <Select
                  multiple
                  disableUnderline
                  {...register("type")}
                  onChange={typeChange}
                  displayEmpty={true}
                  value={type}
                  classes={{ root: classes.select }}
                  renderValue={
                    type.length === 0
                      ? () => "物件類型"
                      : (selected) => selected.join(", ")
                  }
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                  }}
                >
                  <MenuItem key="全選" value="全選">
                    <FormControlLabel
                      control={
                        <Checkbox
                          className={classes.checkBox}
                          checked={
                            typeArray.length > 0 &&
                            type.length === typeArray.length
                          }
                          indeterminate={
                            type.length > 0 && type.length < typeArray.length
                          }
                        />
                      }
                      label={<Typography variant="subtitle1">全選</Typography>}
                    />
                  </MenuItem>
                  {typeArray.map((item) => (
                    <MenuItem key={item} value={item}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className={classes.checkBox}
                            checked={type.indexOf(item) > -1}
                          />
                        }
                        label={
                          <Typography variant="subtitle1">{item}</Typography>
                        }
                      />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={12} className={classes.buttonBox}>
              <Button
                className={classes.button}
                startIcon={<SearchIcon style={{ fontSize: "28px" }} />}
                onClick={handleSubmit(_submit)}
              >
                查詢
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {search ? (
        <SearchPropertyResult
          data={searchData}
          franchise
          onChangeTab={(v) => {
            onChangeTab(v);
          }}
        />
      ) : (
        <ChoiceProperty
          franchise
          onChangeTab={(v) => {
            onChangeTab(v);
          }}
        />
      )}
    </Box>
  );
}
//TODO
function AboutUs({ data }) {
  return (
    <Container maxWidth="lg">
      <div
        dangerouslySetInnerHTML={{
          __html: `${
            data ??
            `<h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>經營理念</strong></span></h5>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 專業 - 法拍專業能力夠讓客戶放心</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 負責 - 工作態度積極進取，盡心負責任</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 誠信 - 誠實可靠有根據不欺騙、不亂說</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 服務 -以客為尊服務至上，永遠的朋友</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 熱忱 - 熱忱服務客戶感受深，真正有信任</span></p>
        <h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>企業願景</strong></span></h5>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">1.法拍業界TOP1</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">2.公司上市、股利共享</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">3.全國各地成立服務據點</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">4.服務業前100大</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">5.每個員工都有屬於自己的房子</span></p>
        <h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>光榮紀錄</strong></span></h5>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創全國法拍業界法拍屋「四大保證、六大保固」客戶安心尊榮專案之業者。</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創全國法拍業界法拍屋進階式專業武功祕笈『轟天大法』以客戶服務品質提昇為導向之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創法拍教育研究院、法規研究室、實習輔導中心、『將法院拍賣全套實務有系統傳授』並輔導其創業致富門路之業界。</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創法拍行銷、點交專業分離制度，有效提昇服務品質、合法交屋效率、強化專業素質之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家通過ISO9001國際品質管理與品質標準保證認證之法拍業界（SGS Taiwan Ltd.）！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家通過ISO9001認證後，於隔年ISO檢測標準流程與品質榮獲『零缺失』！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行法拍專業報紙『法拍生活報』全彩版媒體之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行精美全系列『法拍屋教學DVD』法拍致富入門、法拍實戰策略、法拍屋月入百萬行銷技巧、法拍業務教育訓練全系列教材、 法拍創業致富要訣、、、等全套DVD之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『講師』身分受邀至『地政士公會』講解法拍實務並創下多年來聽講之代書人數破紀錄之業界權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『講師』身分(內政部核可講師資格)受邀至『地政從業工會』為不動產經紀人講解法拍實務之業界權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行全國第一本法拍屋、金拍屋、銀拍屋系列叢書，連續榮獲金石堂、博客來網路書店法律類暢銷書第一名！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家Super 台灣聯播網 FM98.5 電台、好事聯播網FM90.3電台主動採訪報導 的業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀於台中廣播FM100.7電台錄製『世紀名人錄』節目之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀於好事聯播網FM90.3電台錄製『與成功有約』節目之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『法拍屋專家』身分受邀於謝震武主持『中天電視台』、于美人主持『TVBS電視台』主講法拍屋之業界權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀至全國最大晶圓廠『台積電(TSMC)』講習法拍屋實務之法拍業界權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲中國時報以『富門法拍 專業技術領先群倫』為報導之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲career就業情報以『富門 法拍界的領導品牌』為報導之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲台灣時報以『交易零糾紛創口碑』為報導之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲工商時報以『富門具品牌 市場佔有率高為法拍屋領導品牌』為報導之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲大記元時報以『改變法拍屋歷史 對自己和上天負責造福弱勢購屋族』為報導之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀至全國最大有聲書平台『台苯轉投資之簡單移動科技(台北101大樓)』錄製『法拍屋有聲書』並至文化大學做專題演講之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國唯一獲得 法院民事執行處 法官庭長、律師公會理事長推薦專書的法拍權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代標』規範之法拍實務業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代點』規範之法拍實務業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代交』規範之法拍實務業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">造福國內眾多法拍代標業者、法拍點交業者、購屋者、原屋主，有效提升不動產交易品質，使其更符合公平正義，並保障消費者、原屋主與 承租人權益。</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家接受群健、新唐人電視台及創業搶鮮誌、就業情報、中時、大紀元、工商時報等電視、報章媒體現場採訪之法拍業界權威！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家擁有『100多本以上』法拍專業叢書與教育訓練書籍之法拍實務業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創造出企業寶寶『富門先生』與企業吉祥動物『富門活力豹』之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家有企業系列歌曲《富門之歌》《我心狂熱》《活了五千歲》《追求理想》《瀟灑一生》《金銀島》等數十首企業歌曲之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家實施『交屋安全保障制度』，以『無法交屋原價買回』安全保障機制之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家實施法拍業務人員『考試制度』與『晉升制度』，重視客戶交易安全與提升服務品質之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家施行法拍業務人員『業務作業流程查檢表』與法拍點交專業人員『點交作業流程查檢表』SOP標準化作業之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家全部單位採行『品質稽核制度』，導入企業360度回饋、目標設定、KPI關鍵稽核指標、自我評量系統等電腦化系統之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家製作一系列買法拍屋與被拍賣之「法拍屋權益保障安全交易說明手冊」，贈閱買屋者、原屋主與承租人之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家提供『法拍收費標準表』將法拍各項收費方式公開透明化使消費者交易更有保障之業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家導入CIS、Know-How、ISO、SOP制度化開放法拍屋創業、加盟、兼職創新制度之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家電視CF形象廣告；公車、電台、馬路旗幟、多處定點、各大報、各優質雜誌形象廣告等全面起動之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家製作研發買屋『法拍屋大亨』遊戲軟體，增進買屋樂趣並同時開發出全國法拍物件、客戶與內部管理系統之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家於世貿中心參與創業加盟大展促使法拍業邁向更制度化之法拍業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家擁有代書、不動產經紀人、律師、理財專員，深研法拍屋實務與點交之專業權威經營顧問團隊！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下各級人員均有專屬網站開站系統的房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家可看全省3D街道影像、房屋實景之房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創新研發出無論客戶數多寡1秒即可找出客戶所需物件之房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家98年7月創下法拍屋加盟店正式突破50家歷史紀錄的房地產加盟總部！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創新研發出法拍屋物件1秒即可全部上架至專屬網站之房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下『房仲業、法拍業、代書業』歷史紀錄，榮獲YAHOO知識+房地產分類『最高等級知識長』之房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下房地產業界歷史紀錄，第1榮獲YAHOO知識+房地產與投資2大分類助人王第1名之房地產業界！</span></p>
        <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲工商時報邀請講解『法拍屋進階班』之房地產業界！</span>&nbsp;</p>`
          }`,
        }}
      ></div>
    </Container>
  );
}
//TODO
function QA() {
  const [index, setIndex] = useState(0);
  const tabArray = [
    "自行投標之陷阱與風險",
    "不肖法拍業者之手法",
    "標購法拍屋風險能力比較表",
  ];
  const rows = [
    {
      tableCell1: "公司歷史",
      tableCell2: "十年以上",
      tableCell3: "不定",
      tableCell4: "不定（常倒閉）",
      tableCell5: "無",
    },
    {
      tableCell1: "經驗能力",
      tableCell2: "法拍專業",
      tableCell3: "兼營他業",
      tableCell4: "不足",
      tableCell5: "低",
    },
    {
      tableCell1: "法律專業",
      tableCell2: "權威指標",
      tableCell3: "無專一性",
      tableCell4: "不足",
      tableCell5: "低",
    },
    {
      tableCell1: "點交效率",
      tableCell2: "快速合法",
      tableCell3: "快慢不定",
      tableCell4: "快速非法",
      tableCell5: "高風險",
    },
    {
      tableCell1: "價格建議",
      tableCell2: "資料數據",
      tableCell3: "自行判斷",
      tableCell4: "喊高價格",
      tableCell5: "不知行情",
    },
    {
      tableCell1: "服務品質",
      tableCell2: "TQM管理",
      tableCell3: "風險難定",
      tableCell4: "低劣",
      tableCell5: "無",
    },
    {
      tableCell1: "公司後盾",
      tableCell2: "財務穩健",
      tableCell3: "風險難定",
      tableCell4: "低劣",
      tableCell5: "無",
    },
    {
      tableCell1: "收費標準",
      tableCell2: "合理實在",
      tableCell3: "不定",
      tableCell4: "不定",
      tableCell5: "無",
    },
    {
      tableCell1: "經營團隊",
      tableCell2: "專業分工",
      tableCell3: "無專一性",
      tableCell4: "詐騙黑心",
      tableCell5: "無",
    },
    {
      tableCell1: "巧立名目",
      tableCell2: "細目列舉",
      tableCell3: "避重就輕",
      tableCell4: "名目繁多",
      tableCell5: "無法確保",
    },
    {
      tableCell1: "屋況確保",
      tableCell2: "保全防護",
      tableCell3: "無確定性",
      tableCell4: "不定",
      tableCell5: "不定",
    },
    {
      tableCell1: "產權調查",
      tableCell2: "審查嚴格",
      tableCell3: "粗糙",
      tableCell4: "不足",
      tableCell5: "不足",
    },
    {
      tableCell1: "節費節稅",
      tableCell2: "主動告知",
      tableCell3: "忽略",
      tableCell4: "無",
      tableCell5: "不足",
    },
    {
      tableCell1: "法拍研究",
      tableCell2: "法拍教室",
      tableCell3: "忽略",
      tableCell4: "無",
      tableCell5: "不足",
    },
    {
      tableCell1: "專業叢書",
      tableCell2: "全國第一",
      tableCell3: "無",
      tableCell4: "無",
      tableCell5: "無",
    },
    {
      tableCell1: "客戶保障",
      tableCell2: "安全VIP",
      tableCell3: "低",
      tableCell4: "無",
      tableCell5: "無",
    },
    {
      tableCell1: "網站查詢",
      tableCell2: "功能完善",
      tableCell3: "不定",
      tableCell4: "無",
      tableCell5: "無",
    },
    {
      tableCell1: "經濟效益",
      tableCell2: "省時省錢",
      tableCell3: "無確定性",
      tableCell4: "詐騙黑心",
      tableCell5: "高風險",
    },
  ];
  return (
    <Container maxWidth="lg">
      <TabView
        centered
        tabs={tabArray}
        index={index}
        onChange={(e) => {
          setIndex(e);
        }}
      >
        {
          <Box>
            <Typography>
              {
                "在講求專業分工的現代社會中，【一個人能把一份工作或事業做好已相當不容易】，更何況涉及到《高專業性》與《高技術性》併行且《牽涉法令繁雜》的『拍賣屋』呢？"
              }
            </Typography>
            <Typography>
              {
                "正所謂隔行如隔山，術業有專攻；法拍屋、金拍屋所突顯的專業與實務更是無庸置疑!"
              }
            </Typography>
            <Typography>
              {
                "【富屋法拍】只從事『法拍』，不兼營房屋仲介，是您標購法拍屋最強大的靠山。"
              }
            </Typography>
            <Box paddingTop={"20px"}>
              <Typography>01‧產權調查不清</Typography>
              <Typography>02‧價格評估錯誤</Typography>
              <Typography>03‧屋況無法確保</Typography>
              <Typography>04‧無法交屋之危險</Typography>
              <Typography>05‧違法-被告之危險</Typography>
              <Typography>06‧海蟑螂惡意占有</Typography>
              <Typography>07‧債務人賴皮不走</Typography>
              <Typography>08‧黑道或遇到抗爭</Typography>
              <Typography>09‧不諳點交程序流程</Typography>
              <Typography>10‧協調不易或方法錯誤</Typography>
              <Typography>11‧缺乏專業的法拍顧問</Typography>
              <Typography>12‧拍賣公告解讀有誤</Typography>
              <Typography>13‧沒有經營智囊團隊協助</Typography>
              <Typography>14‧道聽塗說拿血汗錢開玩笑</Typography>
              <Typography>15‧留下祖先牌位</Typography>
              <Typography>16‧留下眾多神明</Typography>
              <Typography>17‧承租中的房屋</Typography>
              <Typography>18‧公告為空屋卻有人居住</Typography>
              <Typography>19‧空屋但得標後馬上出現占有</Typography>
              <Typography>
                20‧缺乏經驗：涉及到《高專業性》與《高技術性》併行且《牽涉法令繁雜》的『拍賣屋』不僅需要不斷研究相關法令更需有豐富的經驗累積，例如投標錯誤、點交不順
              </Typography>
              <Typography>21‧分身乏力、 所付心力不成比例</Typography>
              <Typography>
                22‧專業法令與專業實務多如牛毛：法拍屋、金拍屋等拍賣房屋涉及專業法令與專業實務深廣繁雜多如牛毛
              </Typography>
              <Typography>
                23‧專業能力不足：缺乏專業例如分析能力、專業背景
              </Typography>
              <Typography>
                24‧執行效率不彰：各項程序無法專精，錯誤百出至無法彌補
              </Typography>
              <Typography>
                25‧無配合廠商折扣優惠：缺乏合作廠商長期配合之各項折扣優惠
              </Typography>
              <Typography>
                26‧多花冤枉錢：（管理費、停車費、各項節稅）
              </Typography>
              <Typography>
                27‧債權人或前屋主或前承租人之騷擾：(如設定抵押權人為地下錢莊)
              </Typography>
              <Typography>
                28‧更大金錢損失或無法收尾：想以自行投標來省錢，反而因專業不足而造成更多的金錢損失，或因無法收尾而造成更大的糾紛
              </Typography>
            </Box>
          </Box>
        }
        {
          <Box>
            <Typography>01‧非法營業公司</Typography>
            <Typography>02‧胡亂哄抬價格</Typography>
            <Typography>03‧產權分析錯誤</Typography>
            <Typography>04‧法拍經驗不足</Typography>
            <Typography>05‧服務品質低落</Typography>
            <Typography>06‧收錢卻不做事</Typography>
            <Typography>07‧點交效率不彰</Typography>
            <Typography>08‧故意隱蔽事實</Typography>
            <Typography>09‧違法快速點交房屋</Typography>
            <Typography>10‧不諳法令專業不足</Typography>
            <Typography>11‧惡性倒閉人去樓空</Typography>
            <Typography>12‧巧立名目漫天開價</Typography>
            <Typography>13‧無經營智囊法拍團隊</Typography>
            <Typography>14‧海蟑螂所開設的公司</Typography>
            <Typography>15‧結合債務人強索搬遷費</Typography>
            <Typography>16‧以低廉服務費為號召伺機詐騙</Typography>
            <Typography>17‧假象保證出價及投標人數(人頭投標)</Typography>
            <Typography>
              18‧以親朋好友的名義代為標購，在取得購屋者信任下再伺機詐騙
            </Typography>
          </Box>
        }
        {
          <Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{ border: "1px solid #ddd" }}
                    >
                      比較分析
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ border: "1px solid #ddd" }}
                    >
                      富屋法拍
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ border: "1px solid #ddd" }}
                    >
                      其他業者
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ border: "1px solid #ddd" }}
                    >
                      不肖公司
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ border: "1px solid #ddd" }}
                    >
                      自行投標
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        align="center"
                        style={{ border: "1px solid #ddd" }}
                      >
                        {row.tableCell1}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ border: "1px solid #ddd" }}
                      >
                        {row.tableCell2}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ border: "1px solid #ddd" }}
                      >
                        {row.tableCell3}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ border: "1px solid #ddd" }}
                      >
                        {row.tableCell4}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ border: "1px solid #ddd" }}
                      >
                        {row.tableCell5}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        }
      </TabView>
    </Container>
  );
}

function ConnectUS({ data, propertyData }) {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const Alert = useAlert();
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      minHeight: "100vh",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
    helperText: {
      position: "absolute",
      bottom: 0,
      transform: "translateY(100%)",
    },
  }));
  const classes = useStyles();
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      remark: "",
      vcode: "",
    },
  });

  useEffect(() => {
    if (propertyData) setValue("remark", `我要諮詢=>留言：${propertyData}`);
  }, [propertyData]);
  if (data) {
    return (
      <Container maxWidth="lg">
        <CardContent>
          <Grid container spacing={3}>
            <Grid item>
              <img
                src={require("../../images/logo192.png").default}
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "contain",
                }}
              />
              <Grid item>
                <Grid container justifyContent="center">
                  <Typography>
                    {data.exclusiveWeb?.companyName ?? ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <Typography variant="h6">{`公司地址：${
                    data.exclusiveWeb?.address ?? ""
                  }`}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6">{`服務專線：${
                    data.exclusiveWeb?.phone ?? ""
                  }`}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6">{`聯絡電話：${
                    data.exclusiveWeb?.mobile ?? ""
                  }`}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6">{`傳真：${
                    data.exclusiveWeb?.fax ?? ""
                  }`}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container>
            <Typography>
              感謝瀏覽本網站，如有任何問題歡迎留言諮詢，我們將盡快回覆給您。
            </Typography>
          </Grid>
          <Box py={4} className={classes.formGrid}>
            {/* form area */}
            <Grid container>
              {/* form */}
              <Grid
                container
                xs={12}
                justify={isPhone ? "space-between" : "flex-start"}
                spacing={isTable ? "2" : "4"}
              >
                {/* ANCHOR 姓名 */}
                <Grid item md={4} xs={6}>
                  <Controller
                    name="fullName"
                    control={control}
                    rules={{
                      required: "請輸入姓名",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography variant="body2">姓名</Typography>
                        <TextField
                          placeholder="姓名"
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                        />
                      </>
                    )}
                  />
                </Grid>
                {/* ANCHOR Line 帳號 */}
                <Grid item md={4} xs={6}>
                  <Controller
                    name="lineId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography variant="body2">Line帳號</Typography>
                        <TextField
                          // label="Line帳號"
                          placeholder="Line帳號"
                          {...field}
                          fullWidth
                        />
                      </>
                    )}
                  />
                </Grid>
                {/* ANCHOR 電話 */}
                <Grid item md={4} xs={12}>
                  <Controller
                    name="mobile"
                    control={control}
                    rules={{
                      required: "請輸入電話",
                      pattern: {
                        // value: MobilePattern,
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography variant="body2">電話</Typography>
                        <TextField
                          placeholder="電話"
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                        />
                      </>
                    )}
                  />
                </Grid>

                {/* ANCHOR 備註 */}
                <Grid item xs={12}>
                  <Controller
                    name="remark"
                    control={control}
                    rules={{
                      required: "請輸入留言",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <FormControl
                        size="small"
                        variant="outlined"
                        fullWidth
                        error={error}
                      >
                        <TextareaAutosize
                          {...field}
                          name="message"
                          placeholder="留言"
                          style={{
                            height: "120px",
                            width: "100%",
                            resize: "none",
                            fontSize: "1em",
                            padding: "10px",
                          }}
                        />
                        <FormHelperText className={classes.helperText}>
                          {error && error.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item md={5} xs={3}>
                  <Controller
                    name="vcode"
                    control={control}
                    rules={{
                      validate: (v) => {
                        if (v !== localStorage.getItem("@fullhouseVcode"))
                          return "驗證碼錯誤";
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography variant="body2">驗證碼</Typography>
                        <Grid container item spacing={1} direction="row">
                          <Grid item>
                            <TextField
                              {...field}
                              error={error}
                              helperText={error && error.message}
                              fullWidth
                              size="small"
                            />
                          </Grid>
                          <Grid item>
                            <VerificationCode />
                          </Grid>
                        </Grid>
                      </>
                    )}
                  />
                </Grid>
              </Grid>
              {/* form area end */}
            </Grid>
            {/* button */}

            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                fullWidth
                style={{
                  color: "#fff",
                  backgroundColor: "#E1B663",
                  borderRadius: "40px",
                  height: "50px",
                  width: isTable ? "100%" : "30%",
                  marginTop: "50px",
                }}
              >
                送出
              </Button>
            </Box>
            <Box pt={10}>
              <iframe
                width="100%"
                height="450"
                frameborder="0"
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE&q=${"台中市南屯區大英西一街61號"}`}
                allowfullscreen
              ></iframe>
            </Box>
          </Box>
        </CardContent>
      </Container>
    );
  } else {
    return null;
  }
}

function ResponsiveImage({ src, width, height }) {
  return (
    <div
      style={{
        width,
      }}
      className="responsive-image"
    >
      <div
        style={{
          paddingBottom: (height / width) * 100 + "%",
        }}
      />
      <img src={src} className="responsive-image__image" />
    </div>
  );
}

function FooterIconsModal() {
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    iconBox: {},
    iconButton: {
      transition: "all 0.3s",
      "&+&": {
        marginLeft: "10px",
      },
      "&:hover": {
        transform: "translateY(-10px)",
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    sgvIcon: {
      width: "16px",
      height: "16px",
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const footerIcons = [
    {
      name: "Facebook",
      svg: FbIcon,
      href: "https://www.facebook.com/fuhoohouse/",
    },
    {
      name: "Line",
      svg: LineIcon,
      href: "https://lin.ee/t4fbbTg",
    },
    {
      name: "WhatsApp",
      svg: WhatsApp,
      href: "https://pse.is/3jyhtf",
    },
    {
      name: "WeChat",
      svg: WeChatIcon,
      modalImg: require("../../images/socialIcons/weChatQrCode.webp").default,
    },
  ];
  return (
    <div>
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        className={classes.iconBox}
      >
        {/* svg icons */}
        {footerIcons.map((item) => {
          return (
            <>
              <IconButton
                size="small"
                className={classes.iconButton}
                onClick={item.href ? null : handleOpen}
                href={item.href ? item.href : "javascript:;"}
              >
                {createElement(item.svg)}
              </IconButton>
              <Modal
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <img src={item.modalImg} />
                  </div>
                </Fade>
              </Modal>
            </>
          );
        })}
      </Box>
    </div>
  );
}
